import { fetcher } from '../utils'

export default async (sessionId: number, searchValue: string): Promise<string[]> => {
  return fetcher(`/api/message/search/${sessionId}?searchValue=${searchValue}`, 'GET', undefined)
}
